export default {
    /**
     * Toggles factory test report edit modal open status.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_FACTORY_TEST_EDIT_MODAL (state, data) {
        state.factoryTestModal.isOpen = data.open;
        state.factoryTestModal.editingId = data.id;
        state.factoryTestModal.ticket = data.ticket;

        if (data.open === true) {
            return;
        }

        state.factoryTestModal.autocomplete.types.splice(0, state.factoryTestModal.autocomplete.types.length);
        state.factoryTestModal.autocomplete.technicians.splice(0, state.factoryTestModal.autocomplete.technicians.length);
        state.factoryTestModal.autocomplete.statuses.splice(0, state.factoryTestModal.autocomplete.statuses.length);
        state.factoryTestModal.autocomplete.factoryTestReportsTypes.splice(0, state.factoryTestModal.autocomplete.factoryTestReportsTypes.length);
        state.factoryTestModal.autocomplete.testingSubjects.splice(0, state.factoryTestModal.autocomplete.testingSubjects.length);
        state.factoryTestModal.errors = {};
        state.factoryTestModal.newlyUploadedFiles.splice(0, state.factoryTestModal.newlyUploadedFiles.length);

        let keys = Object.keys(state.factoryTestModal.data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(state.factoryTestModal.data[keys[i]])) {
                state.factoryTestModal.data[keys[i]] = [];
            } else {
                state.factoryTestModal.data[keys[i]] = '';
            }
        }
    },

    /**
     * Sets factory test report edit modal data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FACTORY_TEST_EDIT_MODAL_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            state.factoryTestModal.data[keys[i]] = data[keys[i]];
        }
    },

    /**
     * Sets factory test report creation information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FACTORY_TEST_CREATION_INFO (state, data) {
        state.factoryTestModal.autocomplete.technicians.splice(0, state.factoryTestModal.autocomplete.technicians.length, ...data.technicians);
        state.factoryTestModal.autocomplete.statuses.splice(0, state.factoryTestModal.autocomplete.statuses.length, ...data.statuses);
        state.factoryTestModal.autocomplete.factoryTestReportsTypes.splice(0, state.factoryTestModal.autocomplete.factoryTestReportsTypes.length,
            ...data.factoryTestReportsTypes);
        state.factoryTestModal.autocomplete.testingSubjects.splice(0, state.factoryTestModal.autocomplete.testingSubjects.length, ...data.testingSubjects);
        state.factoryTestModal.data.testings.splice(0, state.factoryTestModal.data.testings.length, ...data.testings);
        state.factoryTestModal.autocomplete.testings.splice(0, state.factoryTestModal.autocomplete.testings.length, ...data.testings);
    },

    /**
     * Sets factory test report edit modal validation errors.
     *
     * @param state State object
     * @param data Errors
     */
    SET_FACTORY_TEST_EDIT_MODAL_ERRORS (state, data) {
        state.factoryTestModal.errors = data;
    },

    /**
     * Toggles factory test report list refresh.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_LIST_REFRESH (state, data) {
        state.factoryTestList.refreshList = data;
    },

    /**
     * Adds new attachment
     *
     * @param state State object
     * @param data Data object
     */
    APPEND_FACTORY_TEST_NEW_ATTACHMENT (state, data) {
        state.factoryTestModal.data.newAttachments.push(data.fileObject);
        state.factoryTestModal.newlyUploadedFiles.push(data.fileName);
    },


    /**
     * Sets factory test report filters information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_INFO (state, data) {
        state.factoryTestList.filterData.types.splice(0, state.factoryTestList.filterData.types.length, ...data.types);
        state.factoryTestList.filterData.statuses.splice(0, state.factoryTestList.filterData.statuses.length, ...data.statuses);
        state.factoryTestList.filterData.assignees.splice(0, state.factoryTestList.filterData.assignees.length, ...data.assignees);
        state.factoryTestList.filterData.testingSubjects.splice(0, state.factoryTestList.filterData.testingSubjects.length, ...data.testingSubjects);
    },

    /**
     * Sets factory test report list filters data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(data[keys[i]])) {
                state.factoryTestList.filters[keys[i]].splice(0, state.factoryTestList.filters[keys[i]].length, ...data[keys[i]]);
            } else {
                if (keys[i] === 'filter') {
                    let filter = data[keys[i]];
                    if ((filter instanceof String || typeof filter == 'string') && filter.length > 200) {
                        filter = filter.substring(0, 200);
                    }
                    state.factoryTestList.filters[keys[i]] = filter;
                } else {
                    state.factoryTestList.filters[keys[i]] = data[keys[i]];
                }
            }
        }
    },

    /**
     * Toggles factory test report list filters sidebar.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_FILTER_SIDEBAR (state, data) {
        state.factoryTestList.filtersOpen = data;
    },

    /**
     * Removes single factory test report list filter.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_FILTER (state, data) {
        for (let i = 0; i < state.factoryTestList.filters[data.field].length; i++) {
            if (data.field === 'statuses') {
                if (state.factoryTestList.filters[data.field][i].name === data.filter.name) {
                    state.factoryTestList.filters[data.field].splice(i, 1);
                }
            } else {
                if (state.factoryTestList.filters[data.field][i].id === data.id) {
                    state.factoryTestList.filters[data.field].splice(i, 1);
                }
            }

        }
    },

    /**
     * Toggles action with reason block.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_ACTION_WITH_REASON (state, data) {
        if (data.open) {
            state.factoryTestModal.actionWithReason.action = data.action;
            state.factoryTestModal.actionWithReason.isOpen = data.open;

            return;
        }

        state.factoryTestModal.actionWithReason.isOpen = data.open;
        state.factoryTestModal.actionWithReason.action = '';
        state.factoryTestModal.actionWithReason.reason = '';
        state.factoryTestModal.actionWithReason.errors = {};
    },

    SET_REFERENCES (state, data) {
        let selected = [];

        for (let j = 0; j < data.selected.length; j++) {
            selected.push(data.selected[j].id);
        }

        for (let i = 0; i < state.factoryTestModal.data[data.field].length; i++) {
            if ((selected.indexOf(state.factoryTestModal.data[data.field][i].id) === -1) && (state.factoryTestModal.data[data.field][i].value === true)) {
                this._vm.$set(state.factoryTestModal.data[data.field][i], 'value', false);
            } else {
                if (selected.indexOf(state.factoryTestModal.data[data.field][i].id) !== -1) {
                    this._vm.$set(state.factoryTestModal.data[data.field][i], 'value', true);
                }
            }
        }
    },
    ADD_TEST (state, id) {
        if (typeof state.factoryTestModal.data.tests === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.factoryTestModal.data, 'tests', []);
        }

        state.factoryTestModal.data.tests.push({
            id: id,
            description: '',
            passed: null,
            test_images: [],
            data_type: 'Models\\FactoryTests\\FactoryTestReportTests',
        });
    },
    ADD_TEST_V2 (state, id) {
        if (typeof state.factoryTestModal.data.testsV2 === 'undefined') {
            // Makes non-existent property reactive
            this._vm.$set(state.factoryTestModal.data, 'testsV2', []);
        }

        state.factoryTestModal.data.testsV2.push({
            id: id,
            description: '',
            assignee: null,
            test_time: null,
            testing_task: '',
            testing_description: '',
            custom_testing: '',
            testing_pressure: '',
            testings: [],
            results_and_recommendations: '',
            passed: null,
            test_images: [],
            attachments: [],
            data_type: 'Models\\FactoryTests\\FactoryTestReportTestV2',
        });
    },

    SET_OPEN_TEST (state, id) {
        state.testOpen = id;
    },

    SET_OPEN_TEST_V2 (state, id) {
        state.testV2Open = id;
    },

    TOGGLE_IS_UPLOADING (state, isUploading) {
        state.isUploading = isUploading;
    },
    SET_TEST_DATA (state, data) {
        let keys = Object.keys(data.data);
        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.factoryTestModal.data.tests[data.index], keys[i], data.data[keys[i]]);
        }
    },
    SET_TEST_V2_DATA (state, data) {
        let keys = Object.keys(data.data);
        for (let i = 0; i < keys.length; i++) {
            // Makes non-existent property reactive
            this._vm.$set(state.factoryTestModal.data.testsV2[data.index], keys[i], data.data[keys[i]]);
        }
    },
    TOGGLE_CONFIRMATION_MODAL (state, data) {
        console.log(state.confirmation);
        state.confirmation.isOpen = data.isOpen;
        if (data.isOpen) {
            state.confirmation.title = data.title;
            state.confirmation.text = data.text;
            state.confirmation.accept = data.accept;
            state.confirmation.acceptText = data.acceptText;
            state.confirmation.cancel = data.cancel;
            state.confirmation.cancelText = data.cancelText;
        } else {
            state.confirmation.title = '';
            state.confirmation.text = '';
            state.confirmation.accept = null;
            state.confirmation.acceptText = null;
            state.confirmation.cancel = null;
            state.confirmation.cancelText = null;
        }
    },

    REMOVE_TEST (state, index) {
        state.factoryTestModal.data.tests.splice(index, 1);
    },
    REMOVE_TEST_V2 (state, index) {
        state.factoryTestModal.data.testsV2.splice(index, 1);
    },

    /**
     * Sets action with reason, reason value.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_REASON (state, data) {
        state.factoryTestModal.actionWithReason.reason = data;
    },

    ADD_TEST_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.factoryTestModal.data.tests[data.index][data.field].push(data.file);
        }
    },

    ADD_TEST_V2_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.factoryTestModal.data.testsV2[data.index][data.field].push(data.file);
        }
    },

    REMOVE_TEST_FILE (state, data) {
        state.factoryTestModal.data.tests[data.index][data.field].splice(data.fileIndex, 1);
    },

    REMOVE_TEST_V2_FILE (state, data) {
        state.factoryTestModal.data.testsV2[data.index][data.field].splice(data.fileIndex, 1);
    },
    REMOVE_SAVED_ATTACHMENT (state, data) {
        state.factoryTestModal.data.attachments = state.factoryTestModal.data.attachments.filter(attachment => attachment.id !== data.attachmentId);
    },

    /**
     * Sets action with reason errors.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_ERRORS (state, data) {
        state.factoryTestModal.actionWithReason.errors = data;
    },

    /**
     * Sets base route for factory test report modal
     *
     * @param state State object
     * @param name base route name
     */
    SET_BASE_ROUTE (state, name) {
        state.factoryTestModal.baseRoute = name;
    },
};
